import { useEffect, useState } from "react";

const debounceDelay = 750;

export const useDebounce = <T>(value: T, delay?: number) => {
    // State and setters for debounced value
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(
        () => {
            // Update debounced value after delay
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay ?? debounceDelay);
            // Cancel the timeout if value changes (also on delay change or unmount)
            // This is how we prevent debounced value from updating if value is changed ...
            // .. within the delay period. Timeout gets cleared and restarted.
            return () => {
                clearTimeout(handler);
            };
        },
        [delay, value] // Only re-call effect if value or delay changes
    );
    return debouncedValue;
};
